import React, {Component} from 'react'
import PropTypes from "prop-types";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import MyTable from "../TableComponents/Table";
import SvGraphics from "../../assets/SvGraphics";
import doctorApi from "../../services/ApiServices/doctorApi";
import {authenticationService} from "../../services/AuthenticationService";


class Patient_Page_RequestHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientRequestsArr: [],
            patientRequestsArrNotExpanded: [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    getStatus(statusID){
        let{statuses}=this.props
        let language = localStorage.getItem('language')
        let index= statuses.findIndex(item=> item.status_ID.toString()===statusID.toString())
        if(index>=0){
            return language==="he" ?statuses[index].status_desc_he:statuses[index].status_desc
        }
        return ""
    }

     async componentDidMount() {
         let {t, patientInfo} = this.props
         let requestStatuses

         let {patientRequestsArr, patientRequestsArrNotExpanded} = this.state
         let patientRequests = patientInfo.Patient_requests ? patientInfo.Patient_requests : []

         for (let i = 0; i < patientRequests.length; i++) {
             if(patientRequests[i].IsRequest){
                 let date = patientRequests[i].requestDate.split('T')[0].split('-').reverse().join('/')
                 let response = await doctorApi.getRequestSummaryReport(patientRequests[i].RequestID,"Request")

                 let requestStatus =  this.getStatus(patientRequests[i].requestStatus)

                 let language = localStorage.getItem('language')
                 language=language?language:"he"
                 let requestType =  patientRequests[i].choose_programm
                 requestType = requestType === "new" ? language ==="he" ? "הוצאת רישיון חדש": "New medical cannabis permit" : requestType
                 requestType = requestType === "renew" ? language ==="he" ?"חידוש רישיון למטופלים קיימים" :"Renew medical cannabis permit": requestType
                 requestType = requestType === "renew2" ?  language ==="he" ?"חידוש רישיון למטופלים חדשים" :"License renewal for new patients": requestType
                  requestType = requestType === "newPrescription" ? language ==="he" ? "הוצאת מרשם חדש": "New medical cannabis Prescription" : requestType
                 requestType = requestType === "renewPrescription" ? language ==="he" ?"חידוש מרשם למטופלים קיימים" :"Renew medical cannabis Prescription": requestType
                 requestType = requestType === "renew2Prescription" ?  language ==="he" ?"חידוש מרשם למטופלים חדשים" :"Prescription renewal for new patients": requestType

                 let isChangeDose =  patientRequests[i].renewCurrentDose
                 isChangeDose = isChangeDose === "Yes" &&language ==="he"? "כן" : isChangeDose
                 isChangeDose = isChangeDose === "No" &&language ==="he"? "לא" : isChangeDose

                 if (i === 0) {
                     patientRequestsArrNotExpanded.push(
                         {
                             Request_date: date,
                             Status: requestStatus,
                             isChangeDose: isChangeDose,
                             Request_Type: requestType,
                             fileUrl: response ? response.data.fileUrl : "",
                             By: "",
                             RequestID: patientRequests[i].RequestID,
                         }
                     )
                 }
                 patientRequestsArr.push(
                     {
                         Request_date: date,
                         Status: requestStatus,
                         isChangeDose: isChangeDose,
                         Request_Type: requestType,
                         fileUrl: response ? response.data.fileUrl : "",
                         By: "",
                         RequestID: patientRequests[i].RequestID,
                     }
                 )
             }


             this.setState({patientRequestsArr, patientRequestsArrNotExpanded})
             }

     }

    getColumns = (t) => {
        return [
            {accessor: 'Request_date', Header: t('patientPage.lastVisitDate'), resizable: false, width: 250},
            {accessor: 'Request_Type', Header: t('patientPage.requestTypeTable'), resizable: false, width: 250},
            {accessor: 'isChangeDose', Header: t('patientPage.isChangeDose'), resizable: false, width: 250},
            {accessor: 'Status', Header: t('patientPage.status'), resizable: false, width: 300},
            {accessor: 'By', Header: t('patientPage.approvingDoc'), resizable: false, width: 300},
            {
                accessor: 'fullSummary', Header: "", resizable: false, width: 300, Cell: ({original}) => {
                    return (
                        <>
                            {original.fileUrl && <SvGraphics svgname={'pdf-icon-blue'}
                                                             onClick={() => window.open(original.fileUrl, '_blank')}
                                                             style={{height: '15px', width: '15px', cursor:'pointer'}}/>
                            }
                            {original.fileUrl && <label
                                onClick={() => window.open(original.fileUrl, '_blank')} style={{color: '#005f7f', cursor:'pointer'}}>Full Summary</label>
                            }
                        </>
                    )
                }
            },
        ]
    }

    render() {
        let {patientRequestsArr, patientRequestsArrNotExpanded} = this.state
        let {t, isExpanded, showDemo} = this.props
        let columns = this.getColumns(t)
        if (showDemo) {
            patientRequestsArrNotExpanded=[
                {
                    Request_date: "03/11/2021",
                    Type: "רגיל",
                    Visit_Summary: "ירידה במינון ליריקה במשך חודש במידה והכל תקין תחזור לחידוש רישיון בעוד 6 חודשים.",
                    CGIC: "",
                    By: "דר\" ישראלי"
                }]
        }
        return (
            <div className={'formBoxes_patientPage-Table'}>

                <MyTable
                    data={isExpanded ? patientRequestsArr : patientRequestsArrNotExpanded}
                    initialData={isExpanded ? patientRequestsArr : patientRequestsArrNotExpanded}
                    columns={columns}
                    defaultPageSize={6}
                    hasShowInfo={false}
                    hasMore={false}
                />
            </div>
        )
    }
}

Patient_Page_RequestHistory.propTypes = {
    isDisabled: PropTypes.bool
}

export default Patient_Page_RequestHistory;
